<template>
  <v-container class="register-type">
    <div class="webform">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6" lg="10">
          <h3 class="text-center">{{ titleRegister }}</h3>
          <p class="txt-form">{{ txtRegister }}</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="7" md="5" lg="5" class="pa-0">
          <div class="card-login pa-3" ref="form">
            <v-card-text class="pa-0">
              <v-text-field
                v-if="organizationType"
                ref="companyName"
                name="companyName"
                label="Nombre de organización"
                filled
                placeholder="Escribe el nombre de tu organización"
                hint="Obligatorio"
                persistent-hint
                class="pa-1"
                v-model="companyName"
                required
                :error-messages="companyErrors"
                @input="$v.companyName.$touch()"
                @blur="$v.companyName.$touch()"
              />
              <v-text-field
                ref="firstName"
                name="firstName"
                label="Nombre"
                filled
                placeholder="Escribe acá tu nombre"
                class="pa-1"
                hint="Obligatorio"
                persistent-hint
                v-model="firstName"
                required
                :error-messages="firstNameErrors"
                @input="$v.firstName.$touch()"
                @blur="$v.firstName.$touch()"
              />
              <v-text-field
                ref="lastName"
                name="lastName"
                label="Apellido"
                filled
                placeholder="Escribe acá tu apellido"
                class="pa-1"
                hint="Obligatorio"
                persistent-hint
                v-model="lastName"
                required
                :error-messages="lastNameErrors"
                @input="$v.lastName.$touch()"
                @blur="$v.lastName.$touch()"
              />
              <v-text-field
                ref="email"
                name="email"
                label="Email"
                filled
                placeholder="Escribe la dirección de correo"
                class="pa-1"
                hint="Obligatorio"
                persistent-hint
                v-model="email"
                :disabled="lockedEmail"
                required
                :error-messages="emailErrors"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              />
            </v-card-text>
            <div class="text-left d-flex">
              <v-checkbox v-model="conditionsPolicy" />
              <p class="text-left">
                He leído y acepto los
                <a
                  class="register__terms"
                  :href="getPrivacyProtection"
                  target="_blank"
                  rel="noopener noreferrer"
                >términos y condiciones de uso</a>, así como las
                <a
                  class="register__terms"
                  :href="getPrivacyProtection"
                  target="_blank"
                  rel="noopener noreferrer"
                >políticas de privacidad y uso de datos personales</a>.
              </p>
            </div>

            <div class="text-left d-flex">
              <v-checkbox v-model="conditionsMessage" />
              <p class="text-left">
                Acepto recibir comunicaciones e información sobre, ofertas actualizaciones y noticias.
              </p>
            </div>
            <v-card-actions class="text-center pa-0">
              <v-btn color="info" :loading="loading" button @click="register" :disabled="!conditionsPolicy || $v.$invalid || loading" class="btn-main-job">REGISTRARSE</v-btn>
            </v-card-actions>
            <div class="text-center">
              <p id="input-error" class="error mt-5" v-if="remoteError">{{ remoteError }}</p>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Social login -->
      <v-row class="social-login">
        <v-col class="text-md-center" cols="12" md="12">
          <v-btn
            class="social-login__btn social-login__btn--google"
            :loading="loading"
            :disabled="loading"
            @click="authenticate('google')"
            elevation="2"
            rounded
          >
            <v-img
              class="social-login__icon"
              :src="require('@/assets/images/google.svg')"
            />
            <v-spacer />
            Ingresa con Google
            <v-spacer />
          </v-btn>
        </v-col>
        <!-- <v-col class="text-md-left" cols="12" md="6">
          <v-btn
            class="social-login__btn social-login__btn--linkedin"
            :loading="loading"
            :disabled="loading"
            @click="authenticate('linkedin')"
            elevation="2"
            x-large
            rounded
          >
            <v-img
              class="social-login__icon"
              :src="require('@/assets/images/linkedin.svg')"
            />
            <v-spacer />
            Ingresa con LinkedIn
            <v-spacer />
          </v-btn>
        </v-col> -->
          
      </v-row>
      <v-row class="mt-8" justify="center">
        <!-- Remember -->
        <v-col cols="12" sm="10">
          <div class="register__remember">
            <p class="register__remember-text">
              Si ya tienes una cuenta,
              <router-link
                to="/login"
                class="register__remember-link"
              >haz click acá</router-link>.
            </p>
            <p class="register__remember-text">
              Si olvidaste tu contraseña,
              <router-link
                to="/password/forget"
                class="register__remember-link"
              >haz click acá</router-link>.
            </p>
            <p class="register__remember-text">
              Si tienes problemas escríbenos directamente a
              <a
                href="mailto:hola@trabajoconsentido.com"
                class="register__remember-link"
              >hola@trabajoconsentido.com</a>.
            </p>
          </div>
        </v-col>


        <div class="box-register">
          <v-row justify="center">
            <v-dialog v-model="finished" persistent max-width="500">
              <div class="register-dialog">
                <v-card class="pa-5 pa-sm-10">
                  <div class="close-dialog">
                    <v-btn color="blue" class="float-right" icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
                  </div>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="4" md="3" lg="4">
                        <v-img src="@/assets/images/logo-tcs.webp" />
                      </v-col>
                      <v-col cols="12" align="center" class="pa-0">
                        <h3 class="text-center">Muchas gracias por tu tiempo<br>¡Está casi listo tu registro!</h3>
                      </v-col>
                      <v-col cols="12" sm="10" md="10">
                        <p class="text-center">Recibirás en unos minutos, un link en tu correo para validar tu mail y crear tu contraseña.<br> <b>¡Te esperamos acá!</b></p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </div>
            </v-dialog>
          </v-row>
        </div>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, minLength, email, requiredIf } from "vuelidate/lib/validators";
import { meta } from "@/libs/mixins";

export default {
    name: "Register",

    props: ["type"],

    mixins: [validationMixin, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Registro",
        });
    }, 

    data() {
        return {
            login: "normal",
            logo: null,
            companyName: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            id: null,
            finished: false,
            errors: [],
            loading: false,
            lockedEmail: false,
            conditionsPolicy: false,
            conditionsMessage: false,
        };
    },

    computed: {
        getPrivacyProtection() {
            return `${process.env.VUE_APP_ROOT_ASSETS}${process.env.VUE_APP_ASSETS_OTHERS_PATH}240108+Terminos+y+Condiciones+Trabajo+con+Sentido.pdf`;
        },
        organizationType() {
            return this.type == "organization";
        },
        remoteError() {
            let err = "";
            if (this.errors.length > 0)
                err = this.errors[this.errors.length - 1];
            return err.toUpperCase() === "NETWORK ERROR" ? "Este correo ya está registrado; intenta recuperar tu contraseña para acceder." : err;
        },
        companyErrors() {
            const errors = [];
            if (!this.$v.companyName.$dirty) return errors;
            !this.$v.companyName.minLength && errors.push("El nombre debe tener más de 3 caracteres");
            !this.$v.companyName.maxLength && errors.push("El nombre debe tener menos de 110 caracteres");
            !this.$v.companyName.required && errors.push("Nombre organización requerido");
            return errors;
        },
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.email && errors.push("Se debe ingresar e-mail valido");
            !this.$v.email.required && errors.push("E-mail es requerido");
            return errors;
        },
        firstNameErrors() {
            const errors = [];
            if (!this.$v.firstName.$dirty) return errors;
            !this.$v.firstName.required && errors.push("El Nombre es requerido");
            return errors;
        },
        lastNameErrors() {
            const errors = [];
            if (!this.$v.lastName.$dirty) return errors;
            !this.$v.lastName.required && errors.push("El Apellido es requerido");
            return errors;
        },
        titleRegister() {
            if (this.type == "organization")
                return "¿Necesitas talentos que se comprometan con tu organización?";
            else return "¿Estás listo para generar impacto?";
        },
        txtRegister() {
            if (this.type == "organization")
                return "Crea tu perfil organización aquí";
            else return "Ingresa a nuestra plataforma y encuentra el trabajo que buscas";
        },
        phoneErrors() {
            const errors = [];
            return errors;
        }
    },

    methods: {
        close() {
            this.finished = false;
            this.loading = false;
        },
        register() {
            // grecaptcha.enterprise.ready(async () => {
            //   const token = await grecaptcha.enterprise.execute('6LfzfGEqAAAAAI1MjtoFprZpbkgNmUkL9Dceqs7i', {action: 'LOGIN'});
            // });
            let form = {
                id: this.id,
                login: this.login,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                logo: this.logo
            };

            if (this.organizationType)
                form.companyName = this.companyName;

            this.loading = true;
            this.$store.dispatch("users/register", form).then((response) => {
                
                this.$store.dispatch("cookies/activity", {
                    path: this.$route.path,
                    activity: "taskComplete"
                });

                if (this.login == "normal") {
                    this.finished = true;
                    this.loading = false;
                } else {
                    setCookie("nps_email", this.email, 3600);
                    this.$router.push({ name: "RedirectionRule" });
                }
            }).catch(err => {
                this.$store.dispatch("cookies/activity", {
                    path: this.$route.path,
                    activity: "taskError",
                    args: JSON.stringify(err)
                });
                console.error(err);
                this.loading = false;
                this.errors = err;
            });
        },
        authenticate(provider) {
            this.loading = true;
            this.$auth.link(provider, {
                provider
            }).then((data) => {
                let profile = data.content.profile;
                this.email = profile.email;
                this.firstName = profile.firstName;
                this.lastName = profile.lastName;
                this.id = profile.id;
                this.logo = profile.logo;
                this.login = "social";
                this.loading = false;
                this.lockedEmail = true;
            }).catch(err => {
                this.loading = false;
                console.error(err);
            });
        },
    },
    
    validations: {
        companyName: {
            required: requiredIf((f) => {
                return f.organizationType;
            }),
            minLength: minLength(3),
            maxLength: maxLength(110)
        },
        firstName: { required },
        lastName: { required },
        email: { required, email },
        phone: {}
    },
};
</script>
